var React = require('react');

function RefreshLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.146 27.998a1 1 0 011 1v9a1 1 0 01-1 1h-8a1 1 0 110-2h7v-8a1 1 0 011-1z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.945 9.003a18 18 0 00-22.123 28.26 1 1 0 01-1.352 1.474 20 20 0 115.2 3.45 1 1 0 11.832-1.818A18 18 0 0033.945 9.003z","key":1})]);
}

RefreshLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = RefreshLight;

RefreshLight.default = RefreshLight;
